module.exports = __webpack_public_path__ + "img/logo_pxcard.605b393d.png";